import axios from "@/api/axios";

const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1);
    n -= 1;
  }
  return new File([u8arr], filename, { type: mime });
};

const send_media = (file_base64) => {
  const file = dataURLtoFile(
    file_base64,
    Math.floor(Math.random() * (10 - 1 + 1)) + 1
  );
  const data = new FormData();
  data.append("file", file, file.name);

  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };

  return axios.post("/api/media_objects", data, config);
};

export default {
  send_media,
};
